import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';
import LandingPageMembershipTabs from '@/app/components/LandingPage/LandingPageMembershipTabs';

const PartnershipsMember = () => {
  return (
    <section className="pt-8 lg:py-20" data-cy="partnerships-member">
      <LandingPageBlurb
        description={{
          alignment: 'top',
          key: 'partnerships_member_copy',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'partnerships_member_title',
          multiline: false,
        }}
        eyebrow="partnerships_member_eyebrow"
      />
      <div className="sm:mt-4 lg:mt-10">
        <LandingPageMembershipTabs />
      </div>
    </section>
  );
};

export default PartnershipsMember;
